import { create } from 'zustand'

import httpClient from '../httpClient'
import { getAuthToken } from '../lib/utils'

const loadingStatuses = new Set()
const loadedTokens = new Map()

const getStatusCount = (response) => {
  const pagination = response?.meta?.pagination || response?.meta || {}

  return (
    pagination.totalCount ??
    pagination.total ??
    pagination.count ??
    pagination.records ??
    response?.data?.length ??
    0
  )
}

const usePendingPhotographersCount = create((set) => ({
  pendingCount: 0,
  declinedCount: 0,
  loading: false,
  fetchCounts: async (statuses = ['pending', 'declined'], force = false) => {
    const authToken = getAuthToken()
    const statusesToFetch = statuses.filter((status) =>
      !loadingStatuses.has(`${authToken}:${status}`) &&
      (force || loadedTokens.get(status) !== authToken)
    )
    if (!statusesToFetch.length) return

    statusesToFetch.forEach((status) => loadingStatuses.add(`${authToken}:${status}`))
    set({ loading: true })
    await Promise.all(statusesToFetch.map(async (status) => {
      try {
        const response = await httpClient('photographers', {
          params: { status, page: 1, per_page: 1 },
        })
        if (getAuthToken() !== authToken) return

        set({ [`${status}Count`]: getStatusCount(response) })
        loadedTokens.set(status, authToken)
      } catch {
        // Keep the previous count if this status request fails.
      } finally {
        loadingStatuses.delete(`${authToken}:${status}`)
        set({ loading: loadingStatuses.size > 0 })
      }
    }))
  },
}))

export default usePendingPhotographersCount
